<template>
	<div>
		<div v-if="isReconnect" class="reconnect-feedback"> Reconectando... </div>
		<div class='parte-cima direita'>
			<section class='row center'>
				<div class="col-12 row mt-2">
					<div v-if="protocol || personContact.name || personContact.phone || queue" class="d-flex">
						<div class="d-flex m-1 align-items-center">
							<span><i class="fas fa-clipboard"></i></span>
							<p><b>Protocolo: </b></p>
							<p v-if="protocol">{{protocol}}</p>
							<p v-else>----------</p>
						</div>
						<div class="d-flex m-1 align-items-center">
							<span><i class="fas fa-user"></i></span>
							<p><b>Cliente: </b></p>
							<p v-if="personContact.name">{{personContact.name}}</p>
							<p v-else>----------</p>
						</div>
						<div class="d-flex m-1 align-items-center">
							<span><i class="fas fa-phone"></i></span>
							<p><b>Telefone: </b></p>
							<p v-if="personContact.phone">{{personContact.phone}}</p>
							<p v-else>----------</p>
						</div>
						<div class="d-flex m-1 align-items-center">
							<span><i class="fas fa-headset"></i></span>
							<p><b>Fila de Atendimento: </b></p>
							<p v-if="queue">{{queue}}</p>
							<p v-else>----------</p>
						</div>
					</div>
					<div class="d-flex" v-else>
						<div class="d-flex m-1 align-items-center">
							<p></p>
						</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    data() {
        return {
            interval: '',
            time: '',
            timeFormat: '',
			protocol: '',
			personContact: {
				'name': '',
				'phone': '',
			},
			queue: ''
        }
    },
	methods: {
		...mapActions(['']),
		formatCpf(cpf) {
			try {
				cpf = cpf.replace(/[^\d]/g, "");
				return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
			} catch(e) {
				return cpf;
			}
		},
		formatPersonData() {
			try {
				this.person.fullName = this.person.fullName.trim();
			} catch(e) {
				console.error('Cliente sem nome');
			}

			return `<b>Nome:</b> ${this.person.fullName} <b>Idade:</b> ${this.person.age} <b>Data de Nascimento:</b> ${this.person.birthday} <b>CPF:</b> ${this.formatCpf(this.person.CPF)}`;
		},
		formatPersonContact() {
			return `<b>Numero:</b> ${this.personContact.phone}  <b>Protocolo:</b> ${this.protocol}`;
		},
		formathealthInssurance() {
			return `<b>Convenio:</b> ${this.healthInssurance.name} - <b>Registro:</b> ${this.healthInssurance.id}`;
		},
		formatAddress() {
			return `${this.ende.address}, ${this.ende.num}, ${this.ende.city} - ${this.ende.CEP}`;
		},
		async setClientData(client) {
			let clientName = '';
			let phoneEdited = '';
			this.protocol = "";
			this.queue = "";

			if(this.getPhone){
				if(client.type == 'chat'){
					let phoneArr = client.phone.split('@');
					phoneEdited = this.formTelefone(phoneArr[0].substr(2));
				}
				this.personContact = {
					'name': client.name || phoneEdited,
					'phone': phoneEdited,	
				}
				if(client.queue == 'entrante'){
					this.queue = 'Atendimento Ativo';
				}
				else {
					this.queue = client.queue;
				}
				this.protocol = client.protocol;
			}
			
			if(client.phone && client.type == 'phone'){
				this.protocol = client.protocol;
				this.queue = client.queue;
				clientName = await axios(`/share-client-cnpj?share=${client.phone}`).then(response => {
					if(response.data.length > 0){
						return response.data[0].name;
					}
					else{
						return this.formTelefone(client.phone);
					}
				})
				this.personContact = {
					'name': clientName,
					'phone': this.formTelefone(client.phone),
				}
			}
		},
		formTelefone(tel) {
			if( (tel.length == 10) || (tel.length == 11) ) {
				const v1 = tel.replace(/\D/g,"");
				const v2 = v1.replace(/^(\d{2})(\d)/g,"($1) $2");
				const v3 = v2.replace(/(\d)(\d{4})$/,"$1-$2");
				
				return v3;
			}
			tel=tel.replace(/\D/g,"")
			tel=tel.replace(/^(\d)/,"+$1")
			tel=tel.replace(/(.{3})(\d)/,"$1($2")
			tel=tel.replace(/(.{6})(\d)/,"$1)$2")
			if(tel.length == 12) {
				tel=tel.replace(/(.{1})$/,"-$1")
			}
			else if (tel.length == 13) {
				tel=tel.replace(/(.{2})$/,"-$1")
			}
			else if (tel.length == 14) {
				tel=tel.replace(/(.{3})$/,"-$1")
			}
			else if (tel.length == 15) {
				tel=tel.replace(/(.{4})$/,"-$1")
			}
			else if (tel.length > 15) {
				tel=tel.replace(/(.{4})$/,"-$1")
			}
			tel=tel.replace("("," (");
			tel=tel.replace(")",") ");

			return tel;
		}
	},
    computed: {
        ...mapGetters(['isReconnect', 'getDataConnectLine', 'getPhone']),
    },
	watch: {
		getDataConnectLine(val) {
			console.log('getData', val);
			localStorage.setItem("clienteAtual", JSON.stringify(val));
			this.hasData = !!Object.keys(val).length;
			this.setClientData(val);

			if(Object.keys(val).length === 0){
				this.personContact = {
					'name': '',
					'phone': ''
				}
				this.protocol = ''
				this.queue = ''
			}
		}	
	},
	mounted() {
		if (!localStorage.getItem("clienteAtual")) {
			this.hasData = false;
			return ;
		}

		const clienteAtual = JSON.parse(localStorage.getItem("clienteAtual"));
		if (Object.keys(clienteAtual).length) {
			this.hasData = true;
			this.setClientData(clienteAtual);
		}
	}
}
</script>

<style scoped>
	.center {

		display: flex;
		align-items: center;
		justify-content: center;
	}
	.reconnect-feedback{
		display: flex;
		justify-content: center;
		width: 100%;
		background-color: gray;
		color: white;
	}

	.parte-cima{
		box-shadow: 5px 3px 6px -6px black;
		padding: 1px 5px 2px 20px;
		background-color: #ECF0F1;
		max-height: 10em;
		overflow-x: auto;
	}
	.row{
		margin-right: 0 !important;
	}
	::-webkit-scrollbar {
	 		width: 0.18rem;
	 	}
	 	::-webkit-scrollbar-track {
	 		background: #f38630;
	 	}
	 	::-webkit-scrollbar-thumb {
	 		background: #1c869a;
	 	}
	.espaco-lado-lado{
		max-width: 270px;
		width: 100%;
		margin: 0.1em 0 0.1em 0;
    }
    .img{
        height: 1.7em;
    }
	b{
		font-size: 1.1em;
    	margin-left: 0.5em;
	}
	p {
		margin: 0 5px;
	}
	span{
		font-size: 20px;
	}
</style>
